import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './formularioUsuario.scss';


export const FormularioUsuario = () => {
  const [tipoDocumento, setTipoDocumento] = useState('');
  const [numeroDocumento, setNumeroDocumento] = useState('');
  const [celular, setCelular] = useState('');
  const [terminosAceptados, setTerminosAceptados] = useState(false);
  const [politicasAceptadas, setPoliticasAceptadas] = useState(false);
  const [errores, setErrores] = useState({});
  const navigate = useNavigate();
  /*const [numero, setNumero] = useState('');
  const handleChange = (event) => {
    setNumero(event.target.value);
  };*/

  const handleSubmit = (event) => {
    event.preventDefault();

  
    const errores = {};
    if (!numeroDocumento) {
      errores.numeroDocumento = 'Por favor ingresa tu número de documento.';
    }
    if (!celular) {
      errores.celular = 'Por favor ingresa tu celular.';
    }
    if (!terminosAceptados) {
      errores.terminosAceptados = 'Debes aceptar los términos y condiciones.';
    }
    if (!politicasAceptadas) {
      errores.politicasAceptadas = 'Debes aceptar las políticas de privacidad.';
    }


    if (Object.keys(errores).length > 0) {
      setErrores(errores);
      return;
    }

    if (numeroDocumento === '30216147') {
        const datos = { tipoDocumento, numeroDocumento, celular, terminosAceptados, politicasAceptadas };
        localStorage.setItem('datosUsuario', JSON.stringify(datos));
        navigate('/Planes');
    } else {
        alert('El usuario no es valido.');
    }

    
  };

  return (
    


    <div className="formulario_usuario">
            <form onSubmit={handleSubmit}>
                <div className="row g-0">
                    <div className="col-5">
                        <select id="tipoDocumento" value={tipoDocumento} onChange={(e) => setTipoDocumento(e.target.value)}>                            
                            <option value="dni">DNI</option>
                            <option value="pasaporte">Pasaporte</option>                            
                        </select>
                    </div>
                    <div className="col-7">
                        <div className="documento">                            
                            <input type="number" id="numeroDocumento" placeholder=" " maxLength="8" value={numeroDocumento} onChange={(e) => setNumeroDocumento(e.target.value)} />
                            <label htmlFor="numeroDocumento" className='before'>Número de documento:</label>
                            
                        </div>											
                    </div>
                    {errores.numeroDocumento && <div className="error">{errores.numeroDocumento}</div>}
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="celular">
                            <input type="number" id="celular" placeholder=" " value={celular} onChange={(e) => setCelular(e.target.value)} />
                            <label htmlFor="celular" className='before'>Celular:</label>                            
                            {errores.celular && <div className="error">{errores.celular}</div>}
                        </div>	
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="campo_check">
                            <label>
                                <input type="checkbox" checked={terminosAceptados} onChange={(e) => setTerminosAceptados(e.target.checked)} />
                                Acepto la Política de Privacidad
                            </label>
                            {errores.terminosAceptados && <div className="error">{errores.terminosAceptados}</div>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="campo_check">
                            <label>
                                <input type="checkbox" checked={politicasAceptadas} onChange={(e) => setPoliticasAceptadas(e.target.checked)} />
                                Acepto la Política Comunicaciones Comerciales
                            </label>
                            {errores.politicasAceptadas && <div className="error">{errores.politicasAceptadas}</div>}
                            
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">   
                        <div className="terminos_condiciones">
                            Aplican Términos y Condiciones.       
                        </div>                                      
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <button type="submit">Cotiza aquí</button>
                    </div>
                </div>	
            </form>						
        </div>


  );
};
